import { render, staticRenderFns } from "./PersonalPropertyTaxBill.vue?vue&type=template&id=2dc389fe&"
import script from "./PersonalPropertyTaxBill.vue?vue&type=script&lang=js&"
export * from "./PersonalPropertyTaxBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports